<template>
    <div>
        <app-nav></app-nav>
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-6">
                    <h3> Fiche de {{remplacantById.prenom}} {{remplacantById.nom}}</h3>
                </div>
            </div>         
            <div class="row">
                <div class="col-xs-1 col-sm-1">
                </div>
                <div class="col-xs-12 col-sm-8">
                   
                    <p  class="text-left">
                        <b> Nom: {{ remplacantById.nom}} </b>
                    </p>
                    <p  class="text-left">
                        <b> Prenom: {{ remplacantById.prenom}}</b>
                    </p>
                    <p  class="text-left">
                        <b> Salutation: {{ remplacantById.salutation}}</b>
                    </p>      
                    <p  class="text-left">
                        <b> Ordre: {{ remplacantById.ordre}} </b>
                    </p>
                     <p  class="text-left">
                        <b> URSSAF: {{ remplacantById.urssaf}} </b>
                    </p>
                    </p>
                    <p  class="text-left">
                        <b> Adresse: {{ remplacantById.adresse}} </b>
                    </p>
                    <p  class="text-left">
                        <b> Téléphone: {{ remplacantById.telephone}} </b>
                    </p>
                    <p  class="text-left">
                        <b> Email: {{ remplacantById.email}} </b>
                    </p>
                    <p  class="text-left">
                        <b> Type de contrat: {{ remplacantById.typeContrat}} </b>
                    </p>
                    <p  class="text-left">
                        <b> Autre assurance: {{ remplacantById.autreAssurance? "oui":"non"}} </b>
                    </p>
                     <p  class="text-left">
                        <b> Date de naissance: {{ moment(remplacantById.dateNaiss).isValid()? moment(remplacantById.dateNaiss).format("DD/MM/YYYY"):""}} </b>
                    </p>
                     <p  class="text-left">
                        <b> Lieu de naissance: {{ remplacantById.lieuNaiss }} </b>
                    </p>
                     <p  class="text-left">
                        <b> Actif: {{ remplacantById.actif }} </b>
                    </p>
                   
                        <router-link to="/remplacants" class="">Retour vers la liste</router-link>
                        <br>
                        <router-link :to="{name: 'RemplacantsEdit' , params: { id: remplacantById.id }}"> Editer.</router-link>
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
import AppNav from './AppNav'
import { REMPLACANT_BY_ID_QUERY } from '../constants/graphql'
import moment from 'moment'
moment.locale('fr')
export default {
  name: 'remplacant',
  components: {
    AppNav
  },
  data () {
    return {
      moment: moment,
      remplacantById: {}
    }
  },
  apollo: {
    remplacantById: {
      query: REMPLACANT_BY_ID_QUERY,
      variables() {
        var id = parseInt(this.$route.params.id, 10)
          return{
            id
        }
      }
    }
  }
}
</script>
<style scoped>
body {
  padding-top: 3.5rem;  
}

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}


/* Sidebar navigation */

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}


/*
 * Dashboard
 */


/* Placeholders */

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}

.medecins-form{
    padding-bottom: 60px;
}


</style>




// WEBPACK FOOTER //
// remplacant.vue?5e606d48